import { TextareaAutosize, makeStyles } from "@material-ui/core";
import { useFormikContext } from "formik";
import { FormTextAreaProps } from "../../interface/formik/FormTextAreaProps";

const useStyles = makeStyles({
  textArea: {
    width: "100%",
    fontSize: "16px",
    fontFamily: "inherit",
    padding: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    resize: "vertical" as const,
  },
});

const FormTextArea = ({
  name,
  value,
  placeholder,
  minRows = 5,
}: FormTextAreaProps) => {
  const { setFieldValue } = useFormikContext<any>();
  const classes = useStyles();

  return (
    <TextareaAutosize
      id={name}
      name={name}
      placeholder={placeholder}
      onChange={(e) => setFieldValue(name, e.target.value)}
      value={value ? value : ""}
      aria-label={name}
      minRows={minRows}
      className={classes.textArea}
    />
  );
};

export default FormTextArea;
